module.exports = __webpack_public_path__ + "static/media/go.891e6ea3.wav";